import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class PagesNews {

	static init() {

		// let filters = document.querySelectorAll('.news-filter-options a');
		// let news = document.querySelectorAll('.column-news');
		//
		// filters.forEach( (filter) => {
		// 	filter.addEventListener( "click", (e) => {
		// 		e.preventDefault();
		//
		// 		if( filter.classList.contains('current') ){
		//
		// 			news.forEach( (item) => {
		// 				item.classList.remove('hidden');
		// 			});
		// 			filters.forEach( (filter) => {
		// 				filter.classList.remove('current');
		// 			});
		//
		// 		}else{
		//
		// 			let category = filter.dataset.filter;
		// 			news.forEach( (item) => {
		// 				item.classList.toggle('hidden', item.dataset.category !== category);
		// 			});
		// 			filters.forEach( (filter) => {
		// 				filter.classList.remove('current');
		// 			});
		// 			filter.classList.add('current');
		//
		// 		}
		//
		// 		ScrollTrigger.refresh();
		// 	});
		// });

	}

}
